import { Autocomplete, TextField } from '@mui/material';

import { useServerSearch } from '@/tracker/hooks/useServerSearch';
import { TaskRef } from '@/tracker/types';

type Props = {
  value: TaskRef | null;
  onChange: (value: TaskRef | null) => void;
  /** Стабильная функция (action.bound стора) */
  search: (query: string) => Promise<TaskRef[]>;
};

/** Родительская задача: поиск на сервере по ключу или названию */
const ParentTaskSelect: React.FC<Props> = ({ value, onChange, search }) => {
  const { options, isLoading, setQuery } = useServerSearch({ search });

  return (
    <Autocomplete
      size="small"
      options={options}
      // Фильтрует сервер
      filterOptions={(all) => all}
      loading={isLoading}
      loadingText="Поиск…"
      noOptionsText="Ничего не нашлось"
      value={value}
      onInputChange={(_, query, reason) => reason === 'input' && setQuery(query)}
      getOptionLabel={(option) => `${option.key} ${option.summary}`}
      isOptionEqualToValue={(option, selected) => option.key === selected.key}
      renderOption={({ key: _, ...props }, option) => (
        <li key={option.key} {...props}>
          <span>
            <b>{option.key}</b> {option.summary}
          </span>
        </li>
      )}
      onChange={(_, selected) => onChange(selected)}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Ключ или название"
          slotProps={{ htmlInput: { ...params.inputProps, 'aria-label': 'Родительская задача' } }}
        />
      )}
    />
  );
};

export { ParentTaskSelect };
